// Marks (bold, italic, etc.)
export type Mark = {
  type: string;
  attrs?: Record<string, any>;
};

// Basic text node
export type TextNode = {
  type: 'text';
  text: string;
  marks?: Mark[];
};

/**
 * Safe text-node check for TipTap JSON walks. `'text' in node` throws when `node` is
 * a primitive (e.g. a JSON fragment incorrectly stored as a string in `content`).
 */
export function isTipTapTextNode(node: unknown): node is TextNode {
  return (
    typeof node === 'object' &&
    node !== null &&
    !Array.isArray(node) &&
    'text' in node
  );
}

// Content node (paragraph, heading, etc.)
export type ContentNode = {
  type: string;
  attrs?: Record<string, any>;
  content?: (ContentNode | TextNode)[];
  marks?: Mark[];
};

// Root document (TipTap JSON root)
export type DocumentState = {
  type: 'doc';
  content?: ContentNode[];
};
